'use client';

import type { FC } from 'react';

import { useMediaQuery } from '../../hooks/use-media-query';
import { PopoverRootContext } from './context/popover-root.context';
import { usePopover } from './hooks/use-popover';
import type { PopoverRootPropsInterface } from './types/popover-root.types';

/**
 * @since 10.0.0
 */
export const PopoverRoot: FC<PopoverRootPropsInterface> = (props: PopoverRootPropsInterface) => {
  const { children, modal = true, tone = 'neutral', dividers = true, ...rest } = props;
  const popover = usePopover(rest);
  // TODO: replace with something reusable
  const isSmallBreakpoint = useMediaQuery('only screen and (max-width : 30em)');
  return (
    <PopoverRootContext.Provider
      value={{ popover, modal: modal && isSmallBreakpoint, tone, dividers }}
    >
      {children}
    </PopoverRootContext.Provider>
  );
};

PopoverRoot.displayName = 'Popover.Root';
